import React, { memo } from 'react';

import { Typography2 } from 'uiToolkit/Typography';

import { StyledCompetencyHeaderCell } from '../../common/CommonComponents';

const CompetencyHeader = ({ roles = [] }) => (
  <>
    {roles?.map((role) => (
      <StyledCompetencyHeaderCell key={role.id}>
        <Typography2 color="textSecondary" weight="bold">
          Description for {role.name}
        </Typography2>
      </StyledCompetencyHeaderCell>
    ))}
  </>
);

export default memo(CompetencyHeader);
